import React from "react";

export const SwotAnalysis = () => (
  <>
    <div className="hero">
      <h1>SWOT Analysis</h1>
    </div>
    <section className="hero is-fullheight mb-5">
      <div className="columns">
        <div className="column is-one-quarter fadeLeftMini"></div>
        <div className="column fadeLeftMini">
          <p>
            Strengths: Active major retail partnership (under NDA), zero-carbon 
            positioning, premium pricing (£25-£330), recently launched mobile ozone 
            service (£50+), advanced PureShield ceramic technology, 18-month operational 
            experience with over 1034 cars serviced, B2B relationship development.
          </p>
          <p>
            Weaknesses: Early-stage company with limited market presence, 
            geographic concentration in Surrey & Greater London, small operational 
            scale requiring investment to expand capacity.
          </p>
          <p>
            Opportunities: Secured partnerships ready for scaling, ongoing 
            negotiations with major fuel retailer, eco-conscious market growth, 
            B2B contract potential, franchise expansion possibilities.
          </p>
          <p>
            Threats: Competition from established car wash chains, economic 
            uncertainty affecting discretionary spending, partnership dependency, 
            seasonal demand variations affecting outdoor services.
          </p>
          <button
            className="button is-pulled-right btn"
            title="Swot Analysis"
            onClick={(event) => (window.location.href = "/SwotPlan")}
          >
            <span>Swot Analysis</span>
          </button>
        </div>
        <div className="column is-one-quarter fadeLeftMini"></div>
      </div>
    </section>
  </>
);
